import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: theme.palette.background.paper,
    borderBottom: "1px solid rgba(0,0,0,0.12)",
  },
  appBarContainer: {
    maxWidth: "1280px",
    padding: 0,
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    padding: "0 20px",
  },
  itemsWrapper: {
    margin: "0 -12px",
    "& > *": {
      margin: "0 12px",
    },
    [theme.breakpoints.down("sm")]: {
      margin: "0 -4px",
      "& > *": {
        margin: "0 4px",
      },
    },
  },
  logo: {
    maxWidth: "150px",
  },
}));

export default useStyles;
